import React from 'react';
import { Box, Inscription, WarningCard, WarningIcon } from '@common-fe/common-fe';

import useGetBeneficiaryPaperFormLink from './useGetBeneficiaryPaperFormLink';

const SpecialStatesWarning = () => {
  const beneficiaryPaperFormLink = useGetBeneficiaryPaperFormLink();

  return (
    <WarningCard
      testId="SpecialStatesWarning"
      borderColor="warningBorder"
      icon={<WarningIcon />}
      containerProps={{ pad: { vertical: 'spacing16', horizontal: 'spacing24' } }}
      title={
        <Inscription color="textBody" weight="bold" lineHeight="20px">
          Important Notice for Participants in Community Property States
        </Inscription>
      }
    >
      <Box margin={{ top: 'spacing8', left: 'spacing32' }}>
        <Inscription color="textBody" lineHeight="20px">
          You reside in a community property state. If you choose to designate a beneficiary other than your spouse, you must submit&nbsp;
          <Inscription
            weight="bold"
            color="textAccent"
            cursor="pointer"
            onClick={() => window.open(beneficiaryPaperFormLink, '_blank')}
          >
            a signed beneficiary form
          </Inscription>.
        </Inscription>
        <Inscription color="textBody" lineHeight="20px" weight="bold" margin={{ top: 'spacing4' }}>
          Beneficiary designations will not be valid without your spouse’s signature.
        </Inscription>
      </Box>
    </WarningCard>
  );
};

export default SpecialStatesWarning;
